<template>       
    <FrameView url="https://www.tradespoon.com/members/ytltr.php" title="Live Trading Room Recordings"></FrameView>
</template>

<script>
import FrameView from "../../components/FrameView.vue";

export default {
    name:'LiveTradingRoomRecordings',
    components: { FrameView }    
}
</script>

<style scoped>    
    .iframe-recordings {
        border: 0;
        width: 100%;
        height: 500px;
    }
</style>